function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
var isPeopleLink = function isPeopleLink(url) {
  return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
var getAccountId = function getAccountId(url) {
  var match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
  return match ? match[1] : null;
};
var mentionLinks = function mentionLinks(state) {
  var tokens = [];
  var _iterator = _createForOfIteratorHelper(state.tokens),
    _step;
  try {
    var _loop = function _loop() {
      var _token$children;
      var token = _step.value;
      var tokenChildren = [];

      // We're only looking for inline children
      if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
        tokens.push(token);
        return 1; // continue
      }
      if (token.children) {
        token.children.forEach(function (childToken, i) {
          var _childToken$attrGet, _tokenChildren, _tokenChildren2;
          var url = (_childToken$attrGet = childToken.attrGet('href')) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : '';
          var discardedToken = ['link_close', 'text'].includes(childToken.type) && [(_tokenChildren = tokenChildren[i - 1]) === null || _tokenChildren === void 0 ? void 0 : _tokenChildren.type, (_tokenChildren2 = tokenChildren[i - 2]) === null || _tokenChildren2 === void 0 ? void 0 : _tokenChildren2.type].includes('mention');

          // Discarded tokens are preserved as `null` so index
          // cross-referencing between processed and raw tokens may
          // be preserved, however null are filtered out later.
          if (discardedToken) {
            tokenChildren.push(null);
            return;
          }
          if (childToken.type === 'link_open' && isPeopleLink(url)) {
            var _token$children$conte, _token$children2;
            var mentionText = (_token$children$conte = (_token$children2 = token.children) === null || _token$children2 === void 0 || (_token$children2 = _token$children2[i + 1]) === null || _token$children2 === void 0 ? void 0 : _token$children2.content) !== null && _token$children$conte !== void 0 ? _token$children$conte : '';
            var mentionToken = new state.Token('mention', '', 0);
            mentionToken.content = '';
            mentionToken.block = false;
            mentionToken.level = childToken.level;
            mentionToken.attrSet('id', "".concat(getAccountId(url)));
            if (mentionText) {
              mentionToken.attrSet('text', "@".concat(mentionText));
            }
            tokenChildren.push(mentionToken);
            return;
          }
          tokenChildren.push(childToken);
        });
      }
      var filteredTokenChildren = tokenChildren.filter(function (childToken) {
        return childToken !== null;
      });
      token.children = filteredTokenChildren;
      tokens.push(token);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  state.tokens = tokens;
  return;
};
export default (function (md) {
  return md.core.ruler.push('mention', mentionLinks);
});